import React from 'react';

function Steps() {
  const steps = [
    {
      number: 1,
      title: "Choose Your Adventure",
      description: "Browse our diverse range of small group adventures across the globe. From cultural immersions to wilderness expeditions, find the perfect trip that matches your travel style.",
      icon: (
        <svg className="w-12 h-12 text-gadventures-purple" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5" />
        </svg>
      ),
    },
    {
      number: 2,
      title: "Plan Your Journey",
      description: "Connect with our travel experts to customize your adventure. Get insights about local cultures, must-see destinations, and practical travel tips to prepare for your journey.",
      icon: (
        <svg className="w-12 h-12 text-gadventures-purple" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      ),
    },
    {
      number: 3,
      title: "Experience Authentic Travel",
      description: "Embark on your adventure with a small group of like-minded travelers. Immerse yourself in local cultures, create lasting connections, and make a positive impact wherever you go.",
      icon: (
        <svg className="w-12 h-12 text-gadventures-purple" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
        </svg>
      ),
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-8">
          Your Journey to Authentic Adventure
        </h2>
        <p className="text-xl text-gray-600 text-center mb-12">
          Follow these three simple steps to begin your transformative travel experience with G Adventures.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step) => (
            <div key={step.number} className="bg-white rounded-lg shadow-lg p-6 transition duration-300 ease-in-out transform hover:-translate-y-1 hover:shadow-xl">
              <div className="flex items-center justify-center w-16 h-16 bg-gadventures-purple bg-opacity-10 rounded-full mb-4">
                {step.icon}
              </div>
              <h3 className="text-2xl font-bold text-gadventures-dark mb-2">Step {step.number}: {step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 text-center">
          <a
            href="#get-started"
            className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gadventures-purple hover:bg-gadventures-purple-dark md:py-4 md:text-lg md:px-10"
          >
            Start Your Adventure Today
          </a>
        </div>
      </div>
    </section>
  );
}

export default Steps;
